'use strict';

import contentBlocker from './content-blocker';

class PageSpinner {
    constructor() {
        this.isVisible = false;
        this.isInited = false;
        this.currentOptions = null;
        this.spinnerElement = null;
    }

    init() {
        this.spinnerElement = document.querySelector('.js-page-spinner');
        this.isInited = true;
    }

    show(options = {fade: false, blockContent: false}) {
        if (!this.isInited) {
            this.init();
        }
        this.applyOptions(options);
        this.currentOptions = options;
        if (this.currentOptions.blockContent) {
            contentBlocker.block('page-spinner');
        }
        this.spinnerElement.classList.add('is-visible');
        this.isVisible = true;
    }

    hide() {
        if (this.isVisible) {
            if (this.currentOptions.blockContent) {
                contentBlocker.unblock('page-spinner');
            }
            this.spinnerElement.classList.remove('is-visible');
            this.isVisible = false;
        }
    }

    applyOptions(options) {
        if (options.fade) {
            this.spinnerElement.classList.add('has-fade');
        } else {
            this.spinnerElement.classList.remove('has-fade');
        }
    }
}

let instance = new PageSpinner();
export default instance;



// WEBPACK FOOTER //
// ./app/general/js/page-spinner.js